<template>
    <el-dialog class="common-dialog noHeader register-info-dialog" title="你是帅哥还是美女?" :visible="isShowModal" :show-close="false">
        <div class="content">
            <div class="sex-radio lineBlock" :class="{'selected': sex === 0}" @click="select(0)">
                <div class="img male"></div>
                <span>帅哥</span>
            </div>
            <div class="sex-radio lineBlock" :class="{'selected': sex === 1}" @click="select(1)">
                <div class="img femal"></div>
                <span>美女</span>
            </div>
        </div>
        <el-button type="primary" size="full" @click="saveUserSex()">下一步</el-button>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    data() {
        return {
            sex: null
        }
    },
    computed: {
        ...mapState(['loginStep']),
        isShowModal() {
            return this.loginStep === 'sex';
        }
    },
    methods: {
        ...mapMutations(['setUserInfo', 'setLoginStep']),
        select(sex) {
            this.sex = sex;
        },
        //提交登录
        saveUserSex() {
            if (this.sex === null) {
                self.$message({ type: 'error', message: '请选择性别' });
                return;
            }
            this.setUserInfo({sex: this.sex});
            this.setLoginStep('year');
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 16.25rem;
    padding: 5.4rem 7.15rem;
    border: 1px solid #e6e6e6;
    text-align: center;
}

.sex-radio {
    width: 5.3rem;
    height: 5.3rem;
    cursor: pointer;

    &:first-of-type {
        margin-right: 6.2rem;
    }
    .img {
        width: 100%;
        height: 100%;
        background: url('../../content/images/select-sex.png') no-repeat #d2d2d2;
        background-size: 7.5rem auto;
        border-radius: 50%;
        &.male {
            background-position: 1rem 1rem;
        }
        &.femal {
            background-position: -3.1rem 1rem;
        }
    }
    &.selected .img {
        background-color: #2472e8;
    }
    > span {
        display: block;
        margin-top: 1rem;
        font-size: .9rem;
    }
}
</style>


// WEBPACK FOOTER //
// app/view/login/LoginSex.vue